export default "__VITE_ASSET__3f8b61d5__"